import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles/AboutPage.module.css';
import SmartImage from '../components/SmartImage';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/*
 * Las fotos salen del propio catalogo (se sirven desde el backend), asi el
 * carrusel muestra productos reales en vez de imagenes genericas.
 */
const foto = (archivo: string) => `${API_URL}/uploads/catalogo/${archivo}`;

const productionItems = [
  { id: 1, image: foto('CR-0005_0.webp'), text: "Baterias y ollas para toda la casa, en materiales que duran." },
  { id: 2, image: foto('ES-0920_0.webp'), text: "Todo para la coccion: pizzeras, asaderas y fuentes." },
  { id: 3, image: foto('VE-T001_0.webp'), text: "Vajilla y mesa: porcelana, vidrio y ceramica para cada dia." },
  { id: 4, image: foto('A-8306_0.webp'), text: "Cuchilleria y utensilios de acero inoxidable." },
  { id: 5, image: foto('CR-3757_0.webp'), text: "Organizacion: aceiteras, frascos y sets que ordenan tu cocina." },
  { id: 6, image: foto('CR-2826_0.webp'), text: "Deco y hogar: piezas simples que suman calidez." },
  { id: 7, image: foto('CR-1329_0.webp'), text: "Cafeteras y accesorios para tu momento del dia." },
  { id: 8, image: foto('CR-2620_0.webp'), text: "Bano y limpieza: cestos y dispensers en acero inoxidable." },
];

const AboutPage: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prev) => (prev === productionItems.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prev) => (prev === 0 ? productionItems.length - 1 : prev - 1));
  };

  // Auto-advance
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, [currentIndex]);

  // Reset animation lock
  useEffect(() => {
    const timer = setTimeout(() => setIsAnimating(false), 500);
    return () => clearTimeout(timer);
  }, [currentIndex]);

  return (
    <div className={styles['about-container']}>

      {/* 1. HEADER */}
      <header className={styles['about-header']}>
        <h1>Nosotros</h1>
        <p className={styles['about-subtitle']}>Todo para equipar y disfrutar tu casa.</p>
      </header>

      {/* 2. SECCIÓN: TRAZABILIDAD (CAMPO A MESA) */}
      <section className={`${styles['about-section']} ${styles['trace-section']}`}>
        <h2>Todo para tu casa, en un solo lugar</h2>
        <p className={styles['lead-text']}>
          Reunimos en un mismo lugar todo lo que necesitas para equipar tu casa: desde
          la bateria de cocina y la vajilla de todos los dias, hasta los accesorios de
          bano y las piezas de deco que le dan tu estilo.
        </p>

        {/* CARRUSEL DE PRODUCCIÓN (Reemplaza a los íconos) */}
        <div className={styles['carousel-wrapper']}>
          <div className={styles['carousel-content']}>

            <div className={styles['carousel-image-container']}>
              {/* Las imagenes del catalogo ya vienen optimizadas en WebP
                  desde el importador, asi que no llevan variantes. */}
              <SmartImage
                src={productionItems[currentIndex].image}
                alt={productionItems[currentIndex].text}
                className={styles['carousel-image']}
              />
              <div className={styles['image-overlay']}></div>
            </div>

            <div className={styles['carousel-text-container']}>
              {/* <div className={styles['slide-number']}>0{productionItems[currentIndex].id}</div>  Opcional mostrar número */}
              <h2 className={styles['slide-text']}>
                "{productionItems[currentIndex].text}"
              </h2>
            </div>

            <button className={`${styles['nav-btn']} ${styles['prev-btn']}`} onClick={prevSlide}>
              <FaChevronLeft />
            </button>
            <button className={`${styles['nav-btn']} ${styles['next-btn']}`} onClick={nextSlide}>
              <FaChevronRight />
            </button>
          </div>

          <div className={styles['indicators']}>
            {productionItems.map((_, index) => (
              <button
                key={index}
                className={`${styles['indicator']} ${index === currentIndex ? styles['active'] : ''}`}
                onClick={() => setCurrentIndex(index)}
                aria-label={`Ir a item ${index + 1}`}
              />
            ))}
          </div>
        </div>


      </section>

      {/* 3. SECCIÓN: EMPRESA FAMILIAR */}
      <section className={`${styles['about-section']} ${styles['family-section']}`}>
        <div className={styles['family-content']}>
          <h2>Un bazar con todo para tu casa</h2>
          <p className={styles['family-tagline']}>Cocina · Mesa · Organizacion · Bano · Deco</p>
          <p>
            Trabajamos dia a dia para ofrecerte articulos de primera calidad para
            el hogar. Seleccionamos cada producto verificando materiales y terminacion,
            para que cumpla en el uso cotidiano y te dure muchos anos.
          </p>

          <Link to="/productos" className={styles['btn-about-cta']}>
            Ver nuestros productos
          </Link>
        </div>
      </section>

    </div>
  );
};

export default AboutPage;
